import { Link } from 'react-router-dom';
import { capabilities, getProjectsForCapability } from '../utils/dataModel';

const WhatIDo = () => {
  return (
    <section className="services">
      <div className="services-container">
        <div className="services-header">
          <h2>What I Do</h2>
          <p className="services-subtitle">
            I've worked across the whole span — framing the business problem, building the data
            infrastructure, developing the model, and shipping the thing people actually open.
            That work falls into the three areas below.
          </p>
        </div>
        <div className="services-grid">
          {capabilities.map((capability) => {
            const clients = getProjectsForCapability(capability.id)
              .map(project => project.client_name)
              .join(', ');

            return (
              <Link
                key={capability.id}
                to={`/work#${capability.id}`}
                className="service-card-link"
              >
                <div className="service-card">
                  <div className="capability-glyph" aria-hidden="true">
                    {capability.icon}
                  </div>
                  <div className="service-content">
                    <h3>{capability.title}</h3>
                    <p className="service-description">{capability.description}</p>
                    <p className="service-projects">{clients}</p>
                    <span className="service-link">
                      See the work →
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatIDo;
